import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Blackboxdetails() {
  const location = useLocation();
  const filterData = location.state?.filterData;
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  console.log("filterData", filterData);

  useEffect(() => {
    fetchProducts();
  }, []);

  // const fetchProducts = async () => {
  //   const localUserData = JSON.parse(localStorage.getItem("user"));
  //   if (!localUserData?._id) {
  //     alert("User not logged in.");
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       "https://api.proleverageadmin.in/api/amazon/getitems2",
  //       {
  //         params: {
  //           query:
  //             filterData?.selectedCategories?.map((c) => c.label).join(",") ||
  //             "",
  //           userId: localUserData._id,
  //           country: filterData.country,
  //           min_price: filterData.price.min,
  //           max_price: filterData.price.max,
  //           category_id:
  //             filterData?.selectedCategories?.map((c) => c.value).join(",") ||
  //             "",
  //         },
  //       }
  //     );

  //     const products = response.data.data.products || [];

  //     // ✅ Check if `filterData.sales.min` and `filterData.sales.max` exist
  //     if (filterData?.sales?.min && filterData?.sales?.max) {
  //       const filteredProducts = products.filter((product) => {
  //         const convertedSalesVolume = convertSalesVolume(product.sales_volume);
  //         return (
  //           convertedSalesVolume >= parseInt(filterData.sales.min) &&
  //           convertedSalesVolume <= parseInt(filterData.sales.max)
  //         );
  //       });

  //       setData(filteredProducts); // ✅ Set filtered data if sales range exists
  //     } else {
  //       setData(products); // ✅ If no sales filter, return full product list
  //     }
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //     setError("Failed to load products.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProducts = async () => {
    const localUserData = JSON.parse(localStorage.getItem("user"));
    if (!localUserData?._id) {
      alert("User not logged in.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        "https://api.proleverageadmin.in/api/amazon/getitems2",
        {
          params: {
            query:
              filterData?.selectedCategories?.map((c) => c.label).join(",") ||
              "",
            userId: localUserData._id,
            country: filterData.country,
            min_price: filterData.price.min,
            max_price: filterData.price.max,
            category_id:
              filterData?.selectedCategories?.map((c) => c.value).join(",") ||
              "",
          },
        }
      );

      let products = response.data.data.products || [];

      const minReviewCount = filterData?.reviewCount?.min
        ? parseInt(filterData.reviewCount.min, 10)
        : null;
      const maxReviewCount = filterData?.reviewCount?.max
        ? parseInt(filterData.reviewCount.max, 10)
        : null;

      // ✅ Apply review count filtering if values are valid
      if (minReviewCount !== null || maxReviewCount !== null) {
        products = products.filter((product) => {
          const reviewCount = parseInt(product.product_num_ratings, 10);
          if (isNaN(reviewCount)) return false; // Exclude products with invalid review count

          return (
            (minReviewCount === null || reviewCount >= minReviewCount) &&
            (maxReviewCount === null || reviewCount <= maxReviewCount)
          );
        });
      }

      // ✅ Check if sales range filter exists
      if (filterData?.sales?.min && filterData?.sales?.max) {
        products = products.filter((product) => {
          const convertedSalesVolume = convertSalesVolume(product.sales_volume);
          return (
            convertedSalesVolume >= parseInt(filterData.sales.min) &&
            convertedSalesVolume <= parseInt(filterData.sales.max)
          );
        });
      }

      setData(products); // ✅ Set filtered products
    } catch (error) {
      console.error("Error fetching products:", error);
      setError("Failed to load products.");
    } finally {
      setLoading(false);
    }
  };

  const convertSalesVolume = (volume) => {
    if (!volume) return 0;
    const match = volume.match(/^([\d.]+)([a-zA-Z]*)/);
    if (!match) return 0;
    const value = parseFloat(match[1]);
    const units = { K: 1000, M: 1000000, B: 1000000000 };
    return units[match[2]] ? value * units[match[2]] : value;
  };

  // **Pagination Logic**
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  console.log("data", data);

  const categoryPercentageMapping = {
    "amazon-devices": 45,
    appliances: 8,
    automotive: 12,
    tools: 12,
    "baby-products": 8,
    // "business-industrial-scientific": 12,
    fashion: 5,
    computers: 8,
    // consumer: 8,
    electronics: { upTo100: 15, above100: 8 },
    eyewear: 15,
    "fine-art": { upTo100: 20, upTo1000: 15, upTo5000: 10, above5000: 5 },
    footwear: 15,
    "gift-cards": 20,
    grocery: { upTo15: 8, above15: 15 },
    garden: 15,
    jewelry: { upTo250: 20, above250: 5 },
    mi: 15,
    "office-products": 15,
    pets: 15,
    sporting: 15,
    stripbooks: 10,
    tools: 15,
    "toys-and-game": 15,
    videogames: 15,
    // "video-game-consoles": 8,
    watches: { upTo1500: 16, above1500: 3 },
    "everything-else": 15,
    aps: 15,
    "alexa-skills": 15,
    "live-explorations": 15,
    amazonfresh: 15,
    "amazon-pharmacy": 15,
    "warehouse-deals": 15,
    "mobile-apps": 15,
    "arts-crafts": 15,
    audible: 15,
    courses: 15,
    beauty: 15,
    popular: 15,
    mobile: 15,
    "fashion-womens": 15,
    "fashion-mens": 15,
    "fashion-girls": 15,
    "fashion-baby": 15,
    collectibles: 15,
    financial: 15,
    "edu-alt-content": 15,
    "digital-music": 15,
    lawngarden: 15,
    handmade: 15,
    hpc: 15,
    "local-services": 15,
    industrial: 15,
    "prime-exclusive": 15,
    "digital-text": 15,
    "fashion-luggage": 15,
    luxury: 15,
    magazines: 15,
    "movies-tv": 15,
    "office-products": 15,
    "luxury-beauty": 15,
    "instant-video": 15,
    "smart-home": 15,
    software: 15,
    sporting: 15,
    "specialty-aps-sns": 15,
    "subscribe-with-amazon": 15,
    "under-ten-dollars": 15,
    videogames: 15,
    wholefoods: 15,
  };

  // const calculateFbaFee = (productPrice, category, currency) => {
  //   if (currency !== "USD") return 80;

  //   const categoryData = categoryPercentageMapping[category];
  //   if (!categoryData) return 2;
  //   let fbaFee = 0.3;

  //   if (typeof categoryData === "number") {
  //     fbaFee += productPrice * (categoryData / 100);
  //   } else {
  //     if (category === "electronics") {
  //       fbaFee +=
  //         productPrice <= 100
  //           ? productPrice * 0.15
  //           : 100 * 0.15 + (productPrice - 100) * 0.08;
  //     } else if (category === "furniture") {
  //       fbaFee +=
  //         productPrice <= 200
  //           ? productPrice * 0.15
  //           : 200 * 0.15 + (productPrice - 200) * 0.1;
  //     } else if (category === "fine-art") {
  //       if (productPrice <= 100) fbaFee += productPrice * 0.2;
  //       else if (productPrice <= 1000)
  //         fbaFee += 100 * 0.2 + (productPrice - 100) * 0.15;
  //       else if (productPrice <= 5000)
  //         fbaFee += 100 * 0.2 + 900 * 0.15 + (productPrice - 1000) * 0.1;
  //       else
  //         fbaFee +=
  //           100 * 0.2 + 900 * 0.15 + 4000 * 0.1 + (productPrice - 5000) * 0.05;
  //     } else if (category === "watches") {
  //       fbaFee +=
  //         productPrice <= 1500
  //           ? productPrice * 0.16
  //           : 1500 * 0.16 + (productPrice - 1500) * 0.03;
  //     } else if (category === "jewelry") {
  //       fbaFee +=
  //         productPrice <= 250
  //           ? productPrice * 0.2
  //           : 250 * 0.2 + (productPrice - 250) * 0.05;
  //     } else if (category === "lawn-mowers-snow-throwers") {
  //       fbaFee +=
  //         productPrice <= 500
  //           ? productPrice * 0.15
  //           : 500 * 0.15 + (productPrice - 500) * 0.08;
  //     } else if (category === "grocery") {
  //       fbaFee +=
  //         productPrice <= 15
  //           ? productPrice * 0.08
  //           : 15 * 0.08 + (productPrice - 15) * 0.15;
  //     }
  //   }

  //   return Math.round(fbaFee);
  // };

  const calculateFbaFee = (productPrice, category, currency) => {
    if (currency !== "USD") return 80; // Default FBA fee for non-USD

    const categoryData = categoryPercentageMapping[category];
    if (!categoryData) return 2; // Default FBA fee if no category match

    let fbaFee = 0.3; // Fixed Amazon fee

    if (typeof categoryData === "number") {
      // If category has a fixed percentage
      fbaFee += productPrice * (categoryData / 100);
    } else {
      // Category has tiered pricing (like Electronics, Watches, Jewelry, Fine Art)
      if (categoryData.upTo100 && categoryData.above100) {
        fbaFee +=
          productPrice <= 100
            ? productPrice * (categoryData.upTo100 / 100)
            : 100 * (categoryData.upTo100 / 100) +
              (productPrice - 100) * (categoryData.above100 / 100);
      } else if (categoryData.upTo200 && categoryData.above200) {
        fbaFee +=
          productPrice <= 200
            ? productPrice * (categoryData.upTo200 / 100)
            : 200 * (categoryData.upTo200 / 100) +
              (productPrice - 200) * (categoryData.above200 / 100);
      } else if (categoryData.upTo250 && categoryData.above250) {
        fbaFee +=
          productPrice <= 250
            ? productPrice * (categoryData.upTo250 / 100)
            : 250 * (categoryData.upTo250 / 100) +
              (productPrice - 250) * (categoryData.above250 / 100);
      } else if (categoryData.upTo1500 && categoryData.above1500) {
        fbaFee +=
          productPrice <= 1500
            ? productPrice * (categoryData.upTo1500 / 100)
            : 1500 * (categoryData.upTo1500 / 100) +
              (productPrice - 1500) * (categoryData.above1500 / 100);
      } else if (
        categoryData.upTo1000 &&
        categoryData.upTo5000 &&
        categoryData.above5000
      ) {
        // Fine Art - Multi-tier pricing
        if (productPrice <= 100) {
          fbaFee += productPrice * (categoryData.upTo100 / 100);
        } else if (productPrice <= 1000) {
          fbaFee +=
            100 * (categoryData.upTo100 / 100) +
            (productPrice - 100) * (categoryData.upTo1000 / 100);
        } else if (productPrice <= 5000) {
          fbaFee +=
            100 * (categoryData.upTo100 / 100) +
            900 * (categoryData.upTo1000 / 100) +
            (productPrice - 1000) * (categoryData.upTo5000 / 100);
        } else {
          fbaFee +=
            100 * (categoryData.upTo100 / 100) +
            900 * (categoryData.upTo1000 / 100) +
            4000 * (categoryData.upTo5000 / 100) +
            (productPrice - 5000) * (categoryData.above5000 / 100);
        }
      } else if (categoryData.upTo15 && categoryData.above15) {
        fbaFee +=
          productPrice <= 15
            ? productPrice * (categoryData.upTo15 / 100)
            : 15 * (categoryData.upTo15 / 100) +
              (productPrice - 15) * (categoryData.above15 / 100);
      }
    }

    return Math.round(fbaFee);
  };

  console.log("calculateFbaFee", calculateFbaFee());

  console.log("data", data);

  return (
    <div className="container mt-4">
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th className="poppins-regular">Product</th>
              <th className="poppins-regular">Price</th>
              <th className="poppins-regular">Monthly Sales</th>
              <th className="poppins-regular">Monthly Revenue</th>
              <th className="poppins-regular">Referral Fee</th>
              <th className="poppins-regular">Closing Fee</th>
              <th className="poppins-regular">FBA Fee</th>
              <th className="poppins-regular">Total Fees</th>
              <th className="poppins-regular">Review Count</th>
              <th className="poppins-regular">ASIN</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : (
              paginatedData.map((product) => {
                // Get currency symbol dynamically
                const currencySymbol = product.currency === "USD" ? "$" : "₹";

                // Ensure product price is correctly extracted
                const productPrice =
                  parseFloat(
                    product.product_price?.toString().replace(/[^0-9.]/g, "")
                  ) || 0;
                const convertedSalesVolume = convertSalesVolume(
                  product.sales_volume
                );
                const referralFee = Math.round(productPrice * 0.08) || 0;
                const closingFee = productPrice > 500 ? 50 : 20;
                // const fbaFee = product.currency === "USD" ? 2 : 80;
                const categoryValue =
                  filterData?.selectedCategories?.[0]?.value || "";
                const fbaFee = calculateFbaFee(
                  productPrice,
                  categoryValue,
                  product.currency
                );
                const totalFees =
                  Math.round(referralFee + closingFee + fbaFee) || 0;
                const monthlyRevenue =
                  Math.round(productPrice * convertedSalesVolume) || 0;

                const productDetails = [
                  { label: currencySymbol, value: productPrice },
                  {
                    label: "",
                    value: Math.round(convertedSalesVolume * 1.126),
                  },
                  { label: currencySymbol, value: monthlyRevenue },
                  { label: currencySymbol, value: referralFee },
                  { label: currencySymbol, value: closingFee },
                  { label: currencySymbol, value: fbaFee },
                  { label: currencySymbol, value: totalFees },
                  {
                    label: "",
                    value: product?.product_num_ratings,
                  },

                  { label: "", value: product.asin },
                ];

                return (
                  <tr
                    key={product.asin}
                    style={{ cursor: "pointer" }}
                    onClick={() => window.open(product.product_url, "_blank")}
                  >
                    <td className="poppins-regular">
                      <img
                        src={product.product_photo}
                        alt={product.product_title}
                        width="50"
                        height="50"
                        className="me-2"
                      />
                      {product.product_title}
                    </td>

                    {productDetails.map((detail, index) => (
                      <td className="poppins-regular" key={index}>
                        {detail.label} {detail.value}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
        <button
          className="btn btn-primary poppins-regular"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <span className="fw-bold poppins-regular">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="btn btn-primary poppins-regular"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Blackboxdetails;
